import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/CertificateOfOrigin/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is a Certificate of Origin?
          </h2>
          <p className={cn('about__paragraph')}>
            It’s an official document certifying where the goods were grown, produced, or manufactured.
            Unlike a simple invoice declaration, a formal CO is usually stamped and signed by a third party,
            like a Chamber of Commerce. Think of it as proof of eligibility. It tells customs, "Yes, this
            product allows for a tax break because of the trade deal between our countries."
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href="/download/Resources/FreightTemplates/certificate_of_origin.doc"
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href="/download/Resources/FreightTemplates/certificate_of_origin.pdf"
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;